<template>
<v-container>

<div>
    <v-divider class="mt-12"></v-divider>
    <h2 class="text-center">Configuro mi Tienda</h2>
    <v-divider></v-divider>

            <v-flex 
            
            class="mt-n2 mx-auto"
            v-for="pedido in detallepedido"  :key="pedido"
            v-if="pedido.estado=='#FF0000'"
            xs12 md4>
           
                    <v-alert
                        border="left"
                        colored-border
                        :color="pedido.estado"
                        elevation="10"
                        >
                        <p class="title text-center"><strong>Tienes 1 pedido sin ser visto </strong></p>
                     </v-alert>
            </v-flex>


    <v-layout row wrap pa-2>

        <v-flex class="pa-2">
                        <v-row  no-gutters>
                    <v-col
                        v-for="cate in configuracion"  v-bind:key="cate['.key']"
                        cols="12"
                        class="pa-3 mx-auto "
                        xs="12"
                        sm="12"
                        md="4">

                <v-card class="mx-auto mb-4" >
                        <v-container>
                          <v-row justify="space-between">
                            <v-col cols="auto">
                              <v-img
                              class="mx-auto"
                                height="100"
                                width="100"
                                :src="cate.foto"
                              ></v-img>
                             <h4 block class="text-center pa-1">{{cate.etiqueta}}</h4>
                            </v-col>

                            <v-col
                              cols="auto"
                              class="text-center pl-0"
                            >
                              <v-row
                                class="flex-column ma-0 fill-height"
                                justify="center"
                              >
                                <v-col class="px-0">
                                  <v-btn icon color="green"
                                  href="https://m.me/DomoticaInc" 
                                   target="_blank">                                  
                                    <v-icon>fas fa-question-circle</v-icon>
                                  </v-btn>
                                </v-col>

                                <v-col class="px-0">
                                      <router-link :to="cate.vista" > 
                                  <v-btn icon color="red">
                                    <v-icon>fas fa-arrow-alt-circle-right</v-icon>
                                  </v-btn>
                                      </router-link>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card>
                    </v-col>
                    </v-row>
        </v-flex>
    </v-layout>

    </div>
    </v-container>
</template>

<script>
// @ is an alias to /src
import slide from '@/components/slide';
import cuerpoprincipal from '@/components/cuerpoprincipal'
import { db } from '../db'

export default {
  name: 'gestionTienda',
  components: {
    slide,
    cuerpoprincipal,
  },
     
    firebase: {
        detallepedido:db.database().ref("cabecera").orderByChild('inverso')
    },
  data(){
    return{
      detallepedido:[],
      configuracion:[
        {
          etiqueta:'Mis Tienda',
          foto:'/tienda.png',
          vista:'/gestionconfiguratienda'
        },
        {
          etiqueta:'Lineas de Productos',
          foto:'/categorias.png',
          vista:'/gestionlineasProducto'
        },

       {
          etiqueta:'Mis Clientes',
          foto:'/clientes.png',
          vista:'/gestionClientes'
        },
        {
          etiqueta:'Mis Pedidos',
          foto:'/pedidos.png',
          vista:'/gestionPedidos'
        },
        {
          etiqueta:'Exportar a Facebook',
          foto:'/facebook.png',
          vista:'/facebook'
        },
        {
          etiqueta:'Mis Reportes',
          foto:'/report.png',
        },
        {
          etiqueta:'Mis Abarrotes',
          foto:'/productos.png'
        },
   
      ]
  }
  },

}
</script>
